import { fullRoutes, Routes } from '@/constants/index';

export const getPath = (route: Routes): string => {
  return fullRoutes[route]?.path;
};
